import type { KeyboardEvent } from 'react';

type Result = ModelHookResult<
	{
		borderBackgroundClass: string;
		backgroundClass: string;
	},
	{
		handleKeyDown: (event: KeyboardEvent<HTMLDivElement>) => void;
	}
>;

const SELECTION_CARD_STYLES = {
	checked: {
		borderBackgroundClass: 'bg-linear-to-r from-[#4BAEFF] to-[#0139BC]',
		backgroundClass: 'bg-fill-information-weaker',
	},
	unchecked: {
		borderBackgroundClass: '',
		backgroundClass: 'bg-fill-inverse-strong',
	},
} as const;

export function useSelectionCard(checked: boolean, onSelect: () => void): Result {
	return {
		data: checked ? SELECTION_CARD_STYLES.checked : SELECTION_CARD_STYLES.unchecked,
		actions: {
			handleKeyDown: (event: KeyboardEvent<HTMLDivElement>): void => {
				if (event.key === ' ' || event.key === 'Enter') {
					event.preventDefault();
					onSelect();
				}
			},
		},
	};
}
